// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3Dsj0","productName":"Table_productName__LgJLO"};